import { Grid } from "@material-ui/core";
import { useCallback } from "react";
import { PrimaryButton } from "../../components/button";
import { useAppLoader } from "../../components/loader/app-loader-hook";
import { Widget } from "../../components/widget";
import { AuthService } from "../../store/auth/service";

export const ToolsPage = () => {
  const loader = useAppLoader();

  const onClickHandler = useCallback(
    (x: boolean) => loader(AuthService.downloadMarketingEmail(x).toPromise()),
    [loader]
  );

  return (
    <Widget>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <PrimaryButton onClick={() => onClickHandler(true)}>
                Marketing Emails
              </PrimaryButton>
            </Grid>
            <Grid item xs={12}>
              <PrimaryButton onClick={() => onClickHandler(false)}>
                Marketing Emails&nbsp;<small>(incl. sanctioned users)</small>
              </PrimaryButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Widget>
  );
};
